import { type TileKind, type UnitKind } from "@dailywars/core/engine";

const CODEX_TILE_KINDS: TileKind[] = [
  "sea",
  "road",
  "plain",
  "forest",
  "mountain",
  "dropZone",
  "city",
  "barracks",
  "factory",
  "base",
  "airport",
  "monument",
  "cannon",
];

export function visibleCodexTileKinds(): TileKind[] {
  return CODEX_TILE_KINDS;
}

const TILE_DESCRIPTION: Record<TileKind, string> = {
  plain: "Offers easy movement and more cover than roads.",
  forest: "Slows down vehicles but offers moderate cover.",
  mountain: "Impassable for vehicles. Restricts movements for foot units. Offers great cover.",
  sea: "Impassable for land units.",
  road: "Offers easy movement but less cover than plains.",
  dropZone: "Special tile on escort maps. Reach a Drop Zone tile with every Supply Truck to win.",
  city: "Capturable. Generates 100 funds each turn. Can repair all ground units.",
  barracks: "Capturable. Generates 100 funds each turn. Builds and repairs foot units.",
  factory: "Capturable. Generates 100 funds each turn. Builds and repairs vehicles.",
  base: "Capturable. Generates 100 funds each turn. Acts as a combined barracks and factory.",
  airport: "Capturable. Generates 100 funds each turn. Builds and repairs air units.",
  monument:
    "Capturable. Each owned monument increases your units' firepower by 10%. Some maps require you to capture all monuments to win.",
  cannon:
    "Enemy static weapon. Blocks all unit movement and cannot be captured. Fires once per enemy turn at the most expensive unit in range, dealing a flat 5 HP in damage. Can be destroyed, and some maps require you to destroy all enemy cannons to win.",
};

export function tileDescription(kind: TileKind): string {
  return TILE_DESCRIPTION[kind];
}

export const BUILDING_TILE_LABEL: Record<
  "city" | "barracks" | "factory" | "base" | "airport" | "monument" | "cannon",
  string
> = {
  city: "City",
  barracks: "Barracks",
  factory: "Factory",
  base: "Base",
  airport: "Airport",
  monument: "Monument",
  cannon: "Cannon",
};

export const UNIT_DESCRIPTION: Record<UnitKind, string> = {
  rifleman: "General-purpose infantry. Can capture buildings.",
  rpgInfantry: "Slow anti-armor specialist. Can capture buildings.",
  sniper:
    "Long-range anti-infantry specialist. Can capture buildings. Differs from other indirect fire units in that it can move and shoot in the same turn.",
  artillery: "Cheap artillery vehicle. Cannot move and shoot in the same turn.",
  rockets: "Long-range rocket launcher. Cannot move and shoot in the same turn.",
  lightTank: "Fast armored tank.",
  heavyTank: "Slow but powerful tank.",
  antiAir: "Fast autocannon vehicle strong against infantry and air.",
  missiles: "Long-range missile launcher for anti-air. Cannot move and shoot in the same turn.",
  landTransport:
    "Fast vehicle that can carry infantry. Gains the attack of the carried foot soldier when loaded.",
  battleCopter: "Versatile air unit effective against ground units and other copters.",
  fighterJet: "Fast air unit specialized against other air units.",
  bomber: "Heavy ground-attack air unit.",
  transportCopter: "Carries infantry over any terrain.",
  supplyTruck:
    "Special cargo vehicle found on escort maps. Cannot be built or repaired. Reach a Drop Zone tile with every Supply Truck to win.",
};
